// extracted by mini-css-extract-plugin
export default {"loader":"VideoJS_loader__Pk-mi","videoWrapper":"VideoJS_videoWrapper__L2MkL","hidden":"VideoJS_hidden__209Pm"};